import {
    AssessmentType,
    GlobalEmailTypes,
    SendAssessmentFlowType
} from '../constants-types/Enums';
import { AssessmentReminderConfig } from '../core-data-model/AssessmentReminderConfig';
import { DateFormatUtility } from '../core-utilities/DateFormat.utility';
import { ITranslationService } from '../system-interface/ITranslationService.interface';
import { BehavioralAssessment } from './BehavioralAssessment.model';
import { CognitiveAssessment } from './CognitiveAssessment.model';

export class AssessmentMethods {
    static getReminderConfig(
        assessment: BehavioralAssessment | CognitiveAssessment,
        assessmentType: AssessmentType,
        personId: string,
        lastSentDate: Date,
        TR: ITranslationService,
        dateFormat: DateFormatUtility,
        assessmentId?: string
    ): AssessmentReminderConfig {
        const behavioralType =
            assessmentType === AssessmentType.Behavioral
                ? GlobalEmailTypes.BehavioralAssessmentEmail
                : GlobalEmailTypes.CognitiveAssessmentEmail;
        const personOrJob = {
            isPerson: true,
            id: personId
        };
        if (!assessment) {
            return {
                behavioralType,
                personOrJob,
                reminderType: SendAssessmentFlowType.Send,
                tooltip:
                    behavioralType ===
                    GlobalEmailTypes.BehavioralAssessmentEmail
                        ? TR.key('SendAssessmentPI')
                        : TR.key('SendAssessmentCognitive')
            };
        }
        const displayDT = dateFormat.transformDate(lastSentDate);
        return {
            behavioralType,
            personOrJob,
            reminderType: assessment.isExpired()
                ? SendAssessmentFlowType.SendAgainExpired
                : SendAssessmentFlowType.SendAgainPending,
            tooltip: `${TR.key('label.common-terms.date.sent')} : ${displayDT}`,
            assessmentId,
            dateSent: displayDT
        };
    }
    static getJobTargetReminderConfig(jobId: string): AssessmentReminderConfig {
        const behavioralType = GlobalEmailTypes.JobAssessmentEmail;
        const personOrJob = {
            isPerson: false,
            id: jobId
        };
        return {
            behavioralType,
            personOrJob,
            reminderType: SendAssessmentFlowType.Send
        };
    }
    static getReminderDescription(
        assessment: BehavioralAssessment | CognitiveAssessment,
        date: DateFormatUtility,
        TR: ITranslationService
    ) {
        const descriptionType = assessment.isPending() ? 'pending' : 'expired';
        let labelText = TR.key(`label.common-terms.${descriptionType}`);
        // Handle cognitive aborted case
        if (
            assessment instanceof CognitiveAssessment &&
            assessment.isAborted()
        ) {
            labelText = TR.key('cognitivestatusaborted');
        }
        return `${labelText}
            ${date.transformDate(assessment.sentDate)}`;
    }
}
